import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import FloatingActionButtons from "./Floating_Button";

const MovieCard = ({ movie }) => {
  const url = `https://image.tmdb.org/t/p/w1280/${movie.backdrop_path}`;

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  // const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
  const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <div>
      <div
        className='card'
        key={movie.id}
        style={{
          backgroundImage: `url(${url})`,
          backgroundSize: "cover",
          position: "center center",
        }}
      >
        <div className='inner--border'>
          {!matches ? null : (
            <img
              src={`https://image.tmdb.org/t/p/w500/${movie.poster_path}`}
              alt={movie.title + "poster"}
              className='card--image'
            />
          )}

          <div>
            <div className='card--content'>
              <h3 className='card--title'>{movie.title}</h3>
              <p>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <small
                    style={{
                      fontWeight: "900",
                      lineHeight: "2em",
                      fontSize: matchesXS ? "1rem" : "1.5rem",
                    }}
                  >
                    RELEASE DATE
                  </small>
                  <small>{movie.release_date}</small>
                </div>
              </p>

              <p className='card--desc'>{movie.overview}</p>
            </div>

            <div className='card--info'>
              <p>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <small
                    style={{
                      paddingTop: "1em",
                      lineHeight: "2em",
                      fontSize: matchesXS ? "1rem" : "1.5rem",
                      paddingLeft: ".5em",
                    }}
                  >
                    IMDB RATING
                  </small>
                  <div
                    style={{
                      margin: matchesXS ? "0 auto" : "0",
                      paddingLeft: ".5em",
                    }}
                  >
                    <small
                      style={{
                        display: "flex",
                        background: "white",
                        //   justifyContent: "start",
                        borderRadius: "25px",
                        width: "35px",
                        height: "35px",
                        color: "black",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {movie.vote_average}
                    </small>
                  </div>
                </div>
              </p>
            </div>
          </div>
        </div>
        <FloatingActionButtons />
      </div>
    </div>
  );
};

export default MovieCard;
